
import React, { useState } from 'react';

function FAQSection() {
  const [activeAccordion, setActiveAccordion] = useState(0);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? -1 : index);
  };

  const faqs = [
    {
      question: "How far in advance should I book my move?",
      answer: "We recommend booking your move at least 2-4 weeks in advance to ensure availability, especially during peak seasons."
    },
    {
      question: "Do you provide packing materials?",
      answer: "Yes, we provide high-quality packing materials and professional packing services to ensure your belongings are safe during transport."
    },
    {
      question: "Are my belongings insured during the move?",
      answer: "Yes, all moves are covered by our comprehensive insurance policy to protect your belongings during transportation."
    },
    {
      question: "Do you offer long-distance moving services?",
      answer: "Yes, we offer both local and long-distance moving services across Tamil Nadu and neighboring states."
    }
  ];

  return (
    <div className="our-faqs">
      <div className="container-fluid">
        <div className="row no-gutters">
          <div className="col-lg-6">
            <div className="faq-content-box">
              <div className="our-faqs-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">frequently asked questions</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">Answers to your <span>moving questions</span></h2>
                </div>

                <div className="faq-accordion" id="faqaccordion">
                  {faqs.map((faq, index) => (
                    <div key={index} className="accordion-item wow fadeInUp" data-wow-delay={`${index * 0.2}s`}>
                      <h2 className="accordion-header">
                        <button 
                          className={`accordion-button ${activeAccordion !== index ? 'collapsed' : ''}`}
                          type="button" 
                          onClick={() => toggleAccordion(index)}
                        >
                          {faq.question}
                        </button>
                      </h2>
                      <div className={`accordion-collapse collapse ${activeAccordion === index ? 'show' : ''}`}>
                        <div className="accordion-body">
                          <p>{faq.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="faqs-image">
              <div className="faq-image">
                <figure className="image-anime">
                  <img src="/hellotruck-web-images/faq-image.jpg" alt="" />
                </figure>
              </div>

              <div className="intro-video-button">
                <a href="https://www.instagram.com/hellotruck.in/#" target="_blank" rel="noopener noreferrer" data-cursor-text="Play">
                  <figure>
                    <img src="/hellotruck-web-images/intro-video-circle.svg" alt="" />
                  </figure>

                  <div className="into-video-play-icon">
                    <img src="/hellotruck-web-images/intro-video-play-btn.svg" alt="" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQSection;
